import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { S25RequestedChangesComponent } from "../../standalone/s25.requested.changes.component";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { S25TableModule } from "../s25-table/s25.table.module";
import { S25RuleTreeModule } from "../s25-rule-tree/s25.rule.tree.module";
import { S25DndSortableModule } from "../s25-dnd-sortable/s25.dnd.sortable.module";
import { S25RichTextEditorModule } from "../s25-rich-text-editor/s25.rich.text.editor.module";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25PipesModule } from "../../pipes/s25.pipes.module";

import { IngestionDashboardComponent } from "./ingestion.dashboard.component";
import { IngestionFormComponent } from "./ingestion.form.component";
import { IngestionAdminFormComponent } from "./admin/ingestion.admin.form.component";
import { IngestionAdminComponent } from "./admin/ingestion.admin.component";
import { IngestionSubcategorySelectorComponent } from "./admin/ingestion.subcategory.selector.component";
import { IngestionSearchReportComponent } from "./ingestion.search.report.component";
import { IngestionSearchFormSelectorComponent } from "./ingestion.search.form.selector.component";
import { IngestionFieldSelectorComponent } from "./ingestion.field.selector.component";
import { IngestionAggregationSelectorComponent } from "./ingestion.aggregation.selector.component";
import { IngestionPredicateBuilderComponent } from "./ingestion.predicate.builder.component";
import { IngestionPredicateNodeComponent } from "./ingestion.predicate.node.component";
import { S25NgEventCreationFormWrapperComponent } from "../s25-event-creation-form/s25.event.creation.form.wrapper.component";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25ObjectOccurrenceFieldComponent } from "./field-types/s25.object.occurrence.field.component";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";

@NgModule({
    declarations: [
        IngestionDashboardComponent,
        IngestionFormComponent,
        IngestionAdminFormComponent,
        IngestionAdminComponent,
        IngestionSubcategorySelectorComponent,
        IngestionSearchReportComponent,
        IngestionSearchFormSelectorComponent,
        IngestionFieldSelectorComponent,
        IngestionAggregationSelectorComponent,
        IngestionPredicateBuilderComponent,
        IngestionPredicateNodeComponent,
        S25NgEventCreationFormWrapperComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        S25ButtonComponent,
        S25RequestedChangesComponent,
        S25ModalModule,
        S25ItemModule,
        S25CheckboxModule,
        S25TableModule,
        S25RuleTreeModule,
        S25DndSortableModule,
        S25RichTextEditorModule,
        S25DropdownPaginatedModule,
        S25PipesModule,
        S25EditableModule,
        S25ObjectOccurrenceFieldComponent,
        S25MultiselectModule,
    ],
    providers: [
        IngestionDashboardComponent,
        IngestionFormComponent,
        IngestionAdminFormComponent,
        IngestionAdminComponent,
        IngestionSubcategorySelectorComponent,
        IngestionSearchReportComponent,
        IngestionSearchFormSelectorComponent,
        IngestionFieldSelectorComponent,
        IngestionAggregationSelectorComponent,
        IngestionPredicateBuilderComponent,
        IngestionPredicateNodeComponent,
        S25NgEventCreationFormWrapperComponent,
    ],
    exports: [
        IngestionDashboardComponent,
        IngestionFormComponent,
        IngestionAdminFormComponent,
        IngestionAdminComponent,
        IngestionSubcategorySelectorComponent,
        IngestionSearchReportComponent,
        IngestionSearchFormSelectorComponent,
        IngestionFieldSelectorComponent,
        IngestionAggregationSelectorComponent,
        IngestionPredicateBuilderComponent,
        IngestionPredicateNodeComponent,
        S25NgEventCreationFormWrapperComponent,
    ],
})
export class DataIngestionModule {
    constructor() {}
}
